import * as THREE from 'three';
import { FikoVektor3D } from './FikoVektor3d';
import { geometryAnalysisCache, CachedGeometryAnalysis } from './fiko-olcum/GeometryAnalysisCache';
import { FikoWasmBridge } from './fiko-performance/FikoWasmBridge';
import { FikoThreeJsComponent } from '..';
import { gpuOlcumMotoru } from './fiko-olcum/gpu/GPUOlcumMotoru';


export const hesaplaHacim = (geometry: THREE.BufferGeometry) => {
    const ucgenHacmi = (p1: FikoVektor3D, p2: FikoVektor3D, p3: FikoVektor3D) => {
        return p1.dot(p2.cross(p3)) / 6.0;
    }

    const position = geometry.attributes['position'];
    const hasIndex = geometry.index !== null;
    const faces = position.count / 3;

    let sum = 0;
    let positiveSum = 0;
    let negativeSum = 0;
    let p1 = new THREE.Vector3(),
        p2 = new THREE.Vector3(),
        p3 = new THREE.Vector3();
    for (let i = 0; i < faces; i++) {
        p1.fromBufferAttribute(position, i * 3 + 0);
        p2.fromBufferAttribute(position, i * 3 + 1);
        p3.fromBufferAttribute(position, i * 3 + 2);
        const vol = ucgenHacmi(p1, p2, p3);
        sum += vol;
        if (vol > 0) positiveSum += vol;
        else negativeSum += vol;
    }

    const result = Math.abs(sum) / 100000;

    // Mutlak değer kullan - bazı modellerde üçgenler ters yönlü olabilir
    return result;
}

export const hesaplaAgirlik = (hacim: number, ozKutle: number) => {
    return hacim * ozKutle;
}

export const hesaplaAlan = (geometry: THREE.BufferGeometry) => {
    try {
        const wasmBridge = FikoWasmBridge.getInstance();

        if (wasmBridge.isWasmReady()) {
            const wasmModule = wasmBridge.getWasmModule();

            // Try to get calculateArea from bgFunctions directly if available
            let calculateAreaFunc = wasmModule?.calculateArea;
            if (!calculateAreaFunc && (window as any).__wasmBgFunctions) {
                calculateAreaFunc = (window as any).__wasmBgFunctions.calculateArea;
            }

            if (calculateAreaFunc && typeof calculateAreaFunc === 'function') {
                const position = geometry.attributes['position'].array as Float32Array;
                const indices = geometry.index ? geometry.index.array as Uint32Array : null;

                let indexArray: Uint32Array;
                if (indices) {
                    indexArray = indices;
                } else {
                    indexArray = new Uint32Array(position.length / 3);
                    for (let i = 0; i < indexArray.length; i++) {
                        indexArray[i] = i;
                    }
                }

                const startTime = performance.now();
                const area = calculateAreaFunc(position, indexArray);
                const endTime = performance.now();

              FikoThreeJsComponent.debugLog(`✅ WASM ALAN: ${area}, Süre: ${(endTime - startTime).toFixed(2)}ms`);
                if (typeof area === 'number' && !isNaN(area)) {
                    return area;
                }
            }
        }
    } catch (error) {
    }

    // 📐 JavaScript fallback
    const ucgenAlani = (p1: FikoVektor3D, p2: FikoVektor3D, p3: FikoVektor3D) => {
        var v1 = new THREE.Vector3();
        var v2 = new THREE.Vector3();
        v1 = p1.clone().sub(p2);
        v2 = p1.clone().sub(p3);
        var v3 = new THREE.Vector3();
        v3.crossVectors(v1, v2);
        var s = v3.length() / 2;
        return s
    }

    var area = 0.0;
    const position = geometry.attributes['position'];
    const faces = position.count / 3;
    let p1 = new THREE.Vector3(),
        p2 = new THREE.Vector3(),
        p3 = new THREE.Vector3();
    for (let i = 0; i < faces; i++) {
        p1.fromBufferAttribute(position, i * 3 + 0);
        p2.fromBufferAttribute(position, i * 3 + 1);
        p3.fromBufferAttribute(position, i * 3 + 2);
        area += ucgenAlani(p1, p2, p3);
    }
    return area;
}
/** */
export const hesaplaPerimeter = (geometry: THREE.BufferGeometry) => {
    const ucgenPerimetresi = (p1: FikoVektor3D, p2: FikoVektor3D, p3: FikoVektor3D) => {
        var v1 = new THREE.Vector3();
        var v2 = new THREE.Vector3();
        // Calculate the vector of two edges by two vertex coordinates
        v1 = p1.clone().sub(p2);
        v2 = p1.clone().sub(p3);

        var v3 = new THREE.Vector3();
        // Triangle area calculation
        // v3.addVectors(v1, v2);
        var s = v1.length() - v2.length();
        return s
    }

    var area = 0.0;
    // Traverse all triangle geometry.faces of a geometry, all triangle area accumulation is the surface area of ​​the geometry
    // For irregular surfaces, the higher the degree of subdivision, the higher the area calculation accuracy
    const position = geometry.attributes['position'];
    const faces = position.count / 3;
    let sum = 0;
    let p1 = new THREE.Vector3(),
        p2 = new THREE.Vector3(),
        p3 = new THREE.Vector3();
    for (let i = 0; i < faces; i++) {
        p1.fromBufferAttribute(position, i * 3 + 0);
        p2.fromBufferAttribute(position, i * 3 + 1);
        p3.fromBufferAttribute(position, i * 3 + 2);
        // Call the triangle area calculation function AreaOfTriangle
        area += ucgenPerimetresi(p1, p2, p3); //Triangular Face3 area cumulative calculation
    }
    return area
}

/** */
export const agirlikMerkezi = (geometry: THREE.BufferGeometry) => {
    try {
        // 🚀 Try WASM first
        const wasmBridge = FikoWasmBridge.getInstance();
        if (wasmBridge.isWasmReady()) {
            const wasmModule = wasmBridge.getWasmModule();
            if (wasmModule && wasmModule.calculate_mesh_centroid) {
                const position = geometry.attributes['position'].array as Float32Array;
                const indices = geometry.index ? geometry.index.array as Uint32Array : null;
                let indexArray: Uint32Array;
                if (indices) {
                    indexArray = indices;
                } else {
                    indexArray = new Uint32Array(position.length / 3);
                    for (let i = 0; i < indexArray.length; i++) {
                        indexArray[i] = i;
                    }
                }

                const startTime = performance.now();
                const result = wasmModule.calculate_mesh_centroid(position, indexArray);
                const endTime = performance.now();

                if (result && result.length >= 3) {
                    // Silent mode for geometry calculations
                    return new THREE.Vector3(result[0], result[1], result[2]);
                }
            }
        }
    } catch (error) {
    }

    // 📏 JavaScript fallback
    var center = new THREE.Vector3();
    for (var i = 0; i < geometry.attributes['position'].count; i++) {
        let kontrolNokta = new FikoVektor3D(geometry.attributes['position'].getX(i), geometry.attributes['position'].getY(i), geometry.attributes['position'].getZ(i));
        center = center.clone().add(kontrolNokta);
    }
    return center.divideScalar(geometry.attributes['position'].count)
}

/**
 * Ağırlık merkezi hesaplama - Mesh transformasyonlarını (scale, rotation, position) dikkate alarak
 * NOT: Bu fonksiyon mesh'in dünya matrisini kullanarak gerçek ağırlık merkezini hesaplar
 */
export const agirlikMerkeziScaleli = (geometry: THREE.BufferGeometry, mesh: THREE.Mesh) => {
    var center = new THREE.Vector3();

    // Mesh'in world matrisini güncelle
    mesh.updateMatrixWorld(true);

    // Her vertex'i mesh'in world matrisine göre dönüştür ve topla
    for (var i = 0; i < geometry.attributes['position'].count; i++) {
        let kontrolNokta = new FikoVektor3D(
            geometry.attributes['position'].getX(i),
            geometry.attributes['position'].getY(i),
            geometry.attributes['position'].getZ(i)
        );
        // Mesh'in local uzayındaki noktayı world uzayına dönüştür (scale dahil)
        kontrolNokta.applyMatrix4(mesh.matrixWorld);
        center.add(kontrolNokta);
    }

    return center.divideScalar(geometry.attributes['position'].count)
}


// export const agirlikMerkezi1 = (geometry: THREE.BufferGeometry) => {
//     geometry.computeBoundingBox();
//     var center = new THREE.Vector3();
//     geometry.boundingBox.getCenter(center);
//     // geometry.localToWorld(center);
//     return center;
// }



/** */

export const miYuzeyDuzlemsel = (geometry: THREE.BufferGeometry) => {

    const tripleProduct = (a: FikoVektor3D, b: FikoVektor3D, c: FikoVektor3D) => {
        return a.clone().dot(
            (new THREE.Vector3()).crossVectors(b, c)
        );
    }

    const _isCoPlanar = (a: FikoVektor3D, b: FikoVektor3D, c: FikoVektor3D, d: FikoVektor3D) => {
        var ab = b.clone().sub(a);
        var ac = c.clone().sub(a);
        var ad = d.clone().sub(a);
        return tripleProduct(ab, ac, ad) === 0;
    }

    var isCoPlanar = true;

    let referansNokta0 = new FikoVektor3D(geometry.attributes['position'].getX(0), geometry.attributes['position'].getY(0), geometry.attributes['position'].getZ(0));
    let referansNokta1 = new FikoVektor3D(geometry.attributes['position'].getX(1), geometry.attributes['position'].getY(1), geometry.attributes['position'].getZ(1));
    let referansNokta2 = new FikoVektor3D(geometry.attributes['position'].getX(2), geometry.attributes['position'].getY(2), geometry.attributes['position'].getZ(2));
    for (var i = 3; i < geometry.attributes['position'].count - 1; i++) {
        let kontrolNokta = new FikoVektor3D(geometry.attributes['position'].getX(i), geometry.attributes['position'].getY(i), geometry.attributes['position'].getZ(i));
        isCoPlanar = isCoPlanar && _isCoPlanar(referansNokta0, referansNokta1, referansNokta2, kontrolNokta);
    }

    return isCoPlanar;
}
/** */
export const yuzeyDuzlemAl = (geometry: THREE.BufferGeometry) => {
    let referansNokta0 = new FikoVektor3D(geometry.attributes['position'].getX(0), geometry.attributes['position'].getY(0), geometry.attributes['position'].getZ(0));
    let referansNokta1 = new FikoVektor3D(geometry.attributes['position'].getX(1), geometry.attributes['position'].getY(1), geometry.attributes['position'].getZ(1));
    let referansNokta2 = new FikoVektor3D(geometry.attributes['position'].getX(2), geometry.attributes['position'].getY(2), geometry.attributes['position'].getZ(2));

    return new THREE.Plane().setFromCoplanarPoints(referansNokta0, referansNokta1, referansNokta2);
}
/** */
export const alCizgiUzunluk = (geometry: THREE.BufferGeometry) => {
    let _toplamMesafe = 0;

    for (let i = 0; i < geometry.attributes['position'].count; i++) {
        if (i > 0) {
            const nokta = new FikoVektor3D(geometry.attributes['position'].getX(i - 1), geometry.attributes['position'].getY(i - 1), geometry.attributes['position'].getZ(i - 1));
            const noktaSimdiki = new FikoVektor3D(geometry.attributes['position'].getX(i), geometry.attributes['position'].getY(i), geometry.attributes['position'].getZ(i));
            _toplamMesafe += nokta.distanceTo(noktaSimdiki);
        }
    }
    return _toplamMesafe;
}
/***/
export const miCizgiYon = (geometry: THREE.BufferGeometry) => {
    var isYon = true;

    let referansAcisi = 0;

    for (let i = 0; i < geometry.attributes['position'].count; i++) {
        if (i == 0) {
            const nokta = new FikoVektor3D(geometry.attributes['position'].getX(i + 1), geometry.attributes['position'].getY(i + 1), geometry.attributes['position'].getZ(i + 1)).normalize();
            const noktaSimdiki = new FikoVektor3D(geometry.attributes['position'].getX(i), geometry.attributes['position'].getY(i), geometry.attributes['position'].getZ(i)).normalize();
            referansAcisi = nokta.angleTo(noktaSimdiki);
        } else
            if (i > 0) {
                const nokta = new FikoVektor3D(geometry.attributes['position'].getX(i - 1), geometry.attributes['position'].getY(i - 1), geometry.attributes['position'].getZ(i - 1)).normalize();
                const noktaSimdiki = new FikoVektor3D(geometry.attributes['position'].getX(i), geometry.attributes['position'].getY(i), geometry.attributes['position'].getZ(i)).normalize();
                if (referansAcisi != nokta.angleTo(noktaSimdiki)) {
                    return false;
                }
            }
    }

    return isYon;
}
/** */
export const alCizgiYon = (geometry: THREE.BufferGeometry) => {
    if (!miCizgiYon(geometry)) return null

    try {
        // 🚀 Try WASM first
        const wasmBridge = FikoWasmBridge.getInstance();
        if (wasmBridge.isWasmReady()) {
            const wasmModule = wasmBridge.getWasmModule();
            if (wasmModule && wasmModule.getLineDirection) {
                const p1 = new Float32Array([
                    geometry.attributes['position'].getX(0),
                    geometry.attributes['position'].getY(0),
                    geometry.attributes['position'].getZ(0)
                ]);
                const p2 = new Float32Array([
                    geometry.attributes['position'].getX(1),
                    geometry.attributes['position'].getY(1),
                    geometry.attributes['position'].getZ(1)
                ]);

                const startTime = performance.now();
                const direction = wasmModule.getLineDirection(p1, p2);
                const endTime = performance.now();

                if (direction && direction.length >= 3) {
                  FikoThreeJsComponent.debugLog(`✅ WASM YÖN: [${direction[0].toFixed(3)}, ${direction[1].toFixed(3)}, ${direction[2].toFixed(3)}], Süre: ${(endTime - startTime).toFixed(2)}ms`);
                    return new FikoVektor3D(direction[0], direction[1], direction[2]);
                }
            }
        }
    } catch (error) {
    }

    // 📏 JavaScript fallback
    const nokta = new FikoVektor3D(geometry.attributes['position'].getX(1), geometry.attributes['position'].getY(1), geometry.attributes['position'].getZ(1));
    const noktaSimdiki = new FikoVektor3D(geometry.attributes['position'].getX(0), geometry.attributes['position'].getY(0), geometry.attributes['position'].getZ(0));
    let yon = new FikoVektor3D().subVectors(nokta, noktaSimdiki).normalize();

    return yon;
}
/** */
export const alCizgiNoktaMesafe = (cizgiGeometry: THREE.BufferGeometry, nokta: FikoVektor3D) => {
    let _toplamMesafeler = [];

    for (let i = 0; i < cizgiGeometry.attributes['position'].count; i++) {
        if (i > 0) {
            const noktaOnceki = new FikoVektor3D(cizgiGeometry.attributes['position'].getX(i - 1), cizgiGeometry.attributes['position'].getY(i - 1), cizgiGeometry.attributes['position'].getZ(i - 1));
            const noktaSimdiki = new FikoVektor3D(cizgiGeometry.attributes['position'].getX(i), cizgiGeometry.attributes['position'].getY(i), cizgiGeometry.attributes['position'].getZ(i));

            const line = new THREE.Line3(noktaOnceki, noktaSimdiki);
            const d = calculateDistance(nokta.clone(), line.start, line.end);
            if (!isNaN(d) && d != 0)
                _toplamMesafeler.push(d);
        }
    }
    // 🔧 FIX: Math.min spread overflow için loop kullan
    if (_toplamMesafeler.length === 0) return Infinity;
    let minVal = _toplamMesafeler[0];
    for (let i = 1; i < _toplamMesafeler.length; i++) {
        if (_toplamMesafeler[i] < minVal) minVal = _toplamMesafeler[i];
    }
    return minVal;
}

function calculateDistance(v, l1, lv2) {
    // http://mathworld.wolfram.com/Point-LineDistance3-Dimensional.html
    //              |(x0-x1)x(x0-x2)|
    //  distance =  -----------------
    //                  |x2-x1|
    //
    var diff1 = new THREE.Vector3(0, 0, 0).subVectors(v, l1)
    var diff2 = new THREE.Vector3(0, 0, 0).subVectors(v, lv2)
    var cross = new THREE.Vector3(0, 0, 0).crossVectors(diff1, diff2)
    var diff3 = new THREE.Vector3(0, 0, 0).subVectors(lv2, l1)
    return cross.length() / diff3.length()
}
/***/

/**
 * LEAST-SQUARES CIRCLE FITTING
 * Tüm noktaları kullanarak en doğru çember merkezi ve radiüsünü hesaplar.
 * Bu yöntem 3-nokta yöntemindan daha hassastır çünkü tüm noktaları dikkate alır.
 */
export const leastSquaresCemberFitting = (noktalar: FikoVektor3D[]): { merkez: FikoVektor3D; yaricap: number; rms: number } | null => {
    const n = noktalar.length;
    if (n < 3) return null;

    // Noktaların ağırlık merkezini hesapla
    let xSum = 0, ySum = 0, zSum = 0;
    for (let i = 0; i < n; i++) {
        xSum += noktalar[i].x;
        ySum += noktalar[i].y;
        zSum += noktalar[i].z;
    }
    const xMean = xSum / n;
    const yMean = ySum / n;
    const zMean = zSum / n;

    // Merkezlenmiş noktalar ve momentler için matris elemanlarını hesapla
    let uSum = 0, vSum = 0, wSum = 0;
    let uuSum = 0, uvSum = 0, uwSum = 0, vvSum = 0, vwSum = 0, wwSum = 0;
    let uuuSum = 0, vvvSum = 0, wwwSum = 0;
    let uvvSum = 0, uwwSum = 0, vwwSum = 0;
    let uuvSum = 0, uuwSum = 0, vvwSum = 0;

    for (let i = 0; i < n; i++) {
        const u = noktalar[i].x - xMean;
        const v = noktalar[i].y - yMean;
        const w = noktalar[i].z - zMean;

        uSum += u;
        vSum += v;
        wSum += w;

        uuSum += u * u;
        uvSum += u * v;
        uwSum += u * w;
        vvSum += v * v;
        vwSum += v * w;
        wwSum += w * w;

        uuuSum += u * u * u;
        vvvSum += v * v * v;
        wwwSum += w * w * w;

        uvvSum += u * v * v;
        uwwSum += u * w * w;
        vwwSum += v * w * w;

        uuvSum += u * u * v;
        uuwSum += u * u * w;
        vvwSum += v * v * w;
    }

    // Design matrix A oluştur (Tüm noktalar için minimize etmek için)
    const Auu = uuSum / n - (uSum / n) * (uSum / n);
    const Auv = uvSum / n - (uSum / n) * (vSum / n);
    const Auw = uwSum / n - (uSum / n) * (wSum / n);
    const Avv = vvSum / n - (vSum / n) * (vSum / n);
    const Avw = vwSum / n - (vSum / n) * (wSum / n);
    const Aww = wwSum / n - (wSum / n) * (wSum / n);

    // B vektörünü oluştur
    const Bu = (uuuSum + uvvSum + uwwSum) / (2 * n);
    const Bv = (vvvSum + uuvSum + vwwSum) / (2 * n);
    const Bw = (wwwSum + uuwSum + vvwSum) / (2 * n);

    // Sistem çözmek için 3x3 matris tersini hesapla
    const det =
        Auu * (Avv * Aww - Avw * Avw) -
        Auv * (Auv * Aww - Auw * Avw) +
        Auw * (Auv * Avw - Auw * Avv);

    if (Math.abs(det) < 1e-10) {
        // Matris tekilse, fallback olarak 3-nokta yöntemi kullan
        return null;
    }

    const uc =
        (Bu * (Avv * Aww - Avw * Avw) -
            Auv * (Bv * Aww - Bw * Avw) +
            Auw * (Bv * Avw - Bw * Avv)) / det;

    const vc =
        (Auu * (Bv * Aww - Bw * Avw) -
            Bu * (Auv * Aww - Auw * Avw) +
            Auw * (Auv * Bw - Auw * Bv)) / det;

    const wc =
        (Auu * (Avv * Bw - Avw * Bv) -
            Auv * (Auv * Bw - Auw * Bv) +
            Bu * (Auv * Avw - Auw * Avv)) / det;

    // Çember merkezi orijinal koordinat sistemine geri dönüştür
    const merkez = new FikoVektor3D(xMean + uc, yMean + vc, zMean + wc);

    // Radiüsü hesapla - tüm noktaların merkezden uzaklıklarının ortalaması
    let radiusSum = 0;
    let rmsSum = 0;
    for (let i = 0; i < n; i++) {
        const dist = noktalar[i].distanceTo(merkez);
        radiusSum += dist;
        rmsSum += (dist - (radiusSum / (i + 1))) * (dist - (radiusSum / (i + 1)));
    }

    const yaricap = radiusSum / n;

    // RMS (Root Mean Square) hatasını hesapla
    let rmsError = 0;
    for (let i = 0; i < n; i++) {
        const dist = noktalar[i].distanceTo(merkez);
        rmsError += (dist - yaricap) * (dist - yaricap);
    }
    const rms = Math.sqrt(rmsError / n);

    return {
        merkez: merkez,
        yaricap: sokToleransa(yaricap, 0.005),
        rms: sokToleransa(rms, 0.005)
    };
};

export const miCember = (geometry: THREE.BufferGeometry) => {
    const posAttr = geometry.attributes['position'];
    const count = posAttr.count;

    if (count < 3) return false;

    try {
        // 🚀 Try WASM first (hızlı tespit)
        const wasmBridge = FikoWasmBridge.getInstance();

        if (wasmBridge.isWasmReady()) {
            const wasmModule = wasmBridge.getWasmModule();
            if (wasmModule && wasmModule.detectCircle) {

                const vertices = new Float32Array(count * 3);
                for (let i = 0; i < count; i++) {
                    vertices[i * 3] = posAttr.getX(i);
                    vertices[i * 3 + 1] = posAttr.getY(i);
                    vertices[i * 3 + 2] = posAttr.getZ(i);
                }

                const startTime = performance.now();
                const result = wasmModule.detectCircle(vertices);
                const endTime = performance.now();

                if (result) {
                  FikoThreeJsComponent.debugLog(`✅ WASM ÇEMBER: Yarıçap=${result[3].toFixed(2)}, Merkez=[${result[0].toFixed(2)}, ${result[1].toFixed(2)}, ${result[2].toFixed(2)}], Hata=${result[4].toFixed(2)}, Süre: ${(endTime - startTime).toFixed(2)}ms`);
                }

                if (result && result.length >= 5) {
                    const noktalar: FikoVektor3D[] = [];
                    for (let i = 0; i < count; i++) {
                        noktalar.push(new FikoVektor3D(
                            posAttr.getX(i),
                            posAttr.getY(i),
                            posAttr.getZ(i)
                        ));
                    }

                    const merkez = new FikoVektor3D(result[0], result[1], result[2]);
                    const yaricap = result[3];
                    const error = result[4];

                    // Kalite kontrolü
                    if (!isNaN(yaricap) && yaricap > 0 && error < yaricap * 0.5) {
                        const nokta1 = noktalar[0];
                        const nokta3 = noktalar[count - 1];
                        const aci = aciBul3Nokta(nokta1, merkez, nokta3);

                        let minYaricap = Infinity, maxYaricap = -Infinity;
                        for (let i = 0; i < count; i++) {
                            const uzaklik = noktalar[i].distanceTo(merkez);
                            minYaricap = Math.min(minYaricap, uzaklik);
                            maxYaricap = Math.max(maxYaricap, uzaklik);
                        }

                        return {
                            yaricap: yaricap,
                            cap: 2 * yaricap,
                            merkez: merkez,
                            aci: aci,
                            nokta1: nokta1,
                            nokta2: nokta3,
                            minYaricap: minYaricap,
                            maxYaricap: maxYaricap,
                            ortalamaSapma: error,
                            rms: error
                        };
                    }
                }
            }
        }
    } catch (error) {
    }

    // 📐 JavaScript fallback - LEAST-SQUARES CIRCLE FITTING
    const noktalar: FikoVektor3D[] = [];
    for (let i = 0; i < count; i++) {
        noktalar.push(new FikoVektor3D(
            posAttr.getX(i),
            posAttr.getY(i),
            posAttr.getZ(i)
        ));
    }

    const nokta1 = noktalar[0];
    const nokta3 = noktalar[count - 1];

    let circleResult = leastSquaresCemberFitting(noktalar);

    if (!circleResult) {
        const ortaIndex = Math.floor(count / 2);
        const circumCircle = ThruPointCember([nokta1, noktalar[ortaIndex], nokta3]);

        if (!circumCircle || circumCircle.yaricap === undefined) {
            return false;
        }

        circleResult = {
            merkez: circumCircle.merkez,
            yaricap: circumCircle.yaricap,
            rms: 0
        };
    }

    const aci = aciBul3Nokta(nokta1, circleResult.merkez, nokta3);

    let toplamSapma = 0;
    let minYaricap = Infinity;
    let maxYaricap = -Infinity;

    for (let i = 0; i < count; i++) {
        const uzaklik = noktalar[i].distanceTo(circleResult.merkez);
        toplamSapma += Math.abs(uzaklik - circleResult.yaricap);
        minYaricap = Math.min(minYaricap, uzaklik);
        maxYaricap = Math.max(maxYaricap, uzaklik);
    }

    const ortalamaSapma = toplamSapma / count;

    if (isNaN(circleResult.yaricap) || circleResult.yaricap === 0) {
        return false;
    }

    return {
        yaricap: circleResult.yaricap,
        cap: 2 * circleResult.yaricap,
        merkez: circleResult.merkez,
        aci: aci,
        nokta1: nokta1,
        nokta2: nokta3,
        minYaricap: minYaricap,
        maxYaricap: maxYaricap,
        ortalamaSapma: ortalamaSapma,
        rms: circleResult.rms
    };
}

/** */
export const aciBul3Nokta = (ilkNokta: FikoVektor3D, merkez: FikoVektor3D, sonNokta: FikoVektor3D) => {
    const v1 = {
        x: ilkNokta.x - merkez.x,
        y: ilkNokta.y - merkez.y,
        z: ilkNokta.z - merkez.z,
    };

    // Calculate vector between points 2 and 3
    const v2 = {
        x: sonNokta.x - merkez.x,
        y: sonNokta.y - merkez.y,
        z: sonNokta.z - merkez.z,
    };

    // The dot product of vectors v1 & v2 is a function of the cosine of the
    // angle between them (it's scaled by the product of their magnitudes).

    // Normalize v1
    const v1mag = Math.sqrt(v1.x * v1.x + v1.y * v1.y + v1.z * v1.z);
    const v1norm = {
        x: v1.x / v1mag,
        y: v1.y / v1mag,
        z: v1.z / v1mag,
    };

    // Normalize v2
    const v2mag = Math.sqrt(v2.x * v2.x + v2.y * v2.y + v2.z * v2.z);
    const v2norm = {
        x: v2.x / v2mag,
        y: v2.y / v2mag,
        z: v2.z / v2mag,
    };

    // Calculate the dot products of vectors v1 and v2
    const dotProducts = v1norm.x * v2norm.x + v1norm.y * v2norm.y + v1norm.z * v2norm.z;

    // Extract the angle from the dot products
    const angle = (Math.acos(dotProducts) * 180.0) / Math.PI;

    // Round result to 3 decimal points and return
    return angle;
}


/** */
export const sokToleransa = (num: number, acceptableTolerance: number) => {
    var nearestRoundNumber = Number((num).toFixed(5))// Math.round(num);
    var difference = Math.abs(nearestRoundNumber - num);
    if (difference <= acceptableTolerance) {
        num = nearestRoundNumber;
    }

    return num;
}



export const ThruPointCember = (points: FikoVektor3D[]): any => {
    let XA, YA, ZA: number;
    let XB, YB, ZB: number;
    let XC, YC, ZC: number;
    /** */
    XA = points[0].x; YA = points[0].y; ZA = points[0].z;
    XB = points[1].x; YB = points[1].y; ZB = points[1].z;
    XC = points[2].x; YC = points[2].y; ZC = points[2].z;

    //   Lengths of AB, AC, AC
    let AB = (((XA - XB) ** 2) + ((YA - YB) ** 2) + ((ZA - ZB) ** 2)) ** 0.5
    let BC = (((XB - XC) ** 2) + ((YB - YC) ** 2) + ((ZB - ZC) ** 2)) ** 0.5
    let AC = (((XA - XC) ** 2) + ((YA - YC) ** 2) + ((ZA - ZC) ** 2)) ** 0.5
    //   Direction cosines of AB(ABi,ABj,ABk)
    let ABi = (XB - XA) / AB
    let ABj = (YB - YA) / AB
    let ABk = (ZB - ZA) / AB
    //   Direction cosines of AC(ACi,ACj,ACk)
    let ACi = (XC - XA) / AC
    let ACj = (YC - YA) / AC
    let ACk = (ZC - ZA) / AC
    //   Cosine of angle BAC
    let cosBAC = (AB ** 2 + AC ** 2 - BC ** 2) / (2 * AB * AC)
    let AD = cosBAC * AC
    let CD = (AC ** 2 - AD ** 2) ** 0.5
    //   Position of point D, which is C projected normally onto AB
    let XD = XA + (AD * ABi)
    let YD = YA + (AD * ABj)
    let ZD = ZA + (AD * ABk)
    //   Direction cosines of CD(Cdi,CDj,CDk)
    let CDi = (XC - XD) / CD
    let CDj = (YC - YD) / CD
    let CDk = (ZC - ZD) / CD
    //   Direction cosines of normal to AB and CD
    //   — to be used for rotations of circle centre
    let Ni = (ABk * CDj) - (ABj * CDk)
    let Nj = (ABi * CDk) - (ABk * CDi)
    let Nk = (ABj * CDi) - (ABi * CDj)
    /**
    '   # Diameter of circumscribed circle of a triangle is equal to the
    '   the length of any side divided by sine of the opposite angle.
    '   This is done in a coordinate system where X is colinear with AB, Y is // to CD,
    '   and Z is the normal (N) to X and Y, and the origin is point A
    '   R = D / 2*/
    let sinBAC = (1 - cosBAC ** 2) ** 0.5
    let R = (BC / sinBAC) / 2
    let CAP = (BC / sinBAC)
    //*   Centre of circumscribed circle is point E
    let X2e = AB / 2
    let Y2e = (R ** 2 - X2e ** 2) ** 0.5
    let Z2e = 0
    /**
    '   Transform matrix'                    Rotations                 Translations
    '             ——————————————————————————————————————————————
    '               ABi  ,   ABj  ,  ABk                 Xa
    '               CDi  ,   CDj  ,  CDk                 Ya
    '                Ni  ,    Nj  ,   Nk                 Za
    '             ——————————————————————————————————————————————
    '   Position of circle centre in absolute axis system
    */
    let X_Centre = XA + (X2e * ABi) + (Y2e * CDi) + (Z2e * Ni)
    let Y_Centre = YA + (X2e * ABj) + (Y2e * CDj) + (Z2e * Nj)
    let Z_Centre = ZA + (X2e * ABk) + (Y2e * CDk) + (Z2e * Nk)

    return { yaricap: sokToleransa(R, 0.005), cap: sokToleransa(CAP, 0.005), merkez: new FikoVektor3D(X_Centre, Y_Centre, Z_Centre), aci: null, nokta1: null, nokta2: null }
}


/** */
export const ThruPointCember111 = (points: FikoVektor3D[]): any => {
    let Xa, Ya, Za: number;
    let Xb, Yb, Zb: number;
    let Xc, Yc, Zc: number;
    /** */
    Xa = points[1].x; Ya = points[1].y; Za = points[1].z;
    Xb = points[2].x; Yb = points[2].y; Zb = points[2].z;
    Xc = points[0].x; Yc = points[0].y; Zc = points[0].z;

    /**
     *
     */
    //Given three points in space(A, B, C)
    //   Lengths of AB, AC, AC
    let AB = (((Xa - Xb) ** 2) + ((Ya - Yb) ** 2) + ((Za - Zb) ** 2)) ** 0.5
    let BC = (((Xb - Xc) ** 2) + ((Yb - Yc) ** 2) + ((Zb - Zc) ** 2)) ** 0.5
    let AC = (((Xa - Xc) ** 2) + ((Ya - Yc) ** 2) + ((Za - Zc) ** 2)) ** 0.5
    //   Direction cosines of AB
    let ABi = (Xa - Xb) / AB
    let ABj = (Ya - Yb) / AB
    let ABk = (Za - Zb) / AB
    //   Direction cosines of BC
    let BCi = (Xc - Xb) / BC
    let BCj = (Yc - Yb) / BC
    let BCk = (Zc - Zb) / BC
    //   From point B create two points (G and H) 1000 units along AB and BC
    let Xg = Xb + (1000 * ABi)
    let Yg = Yb + (1000 * ABj)
    let Zg = Zb + (1000 * ABk)
    //
    let Xh = Xb + (1000 * BCi)
    let Yh = Yb + (1000 * BCj)
    let Zh = Zb + (1000 * BCk)
    //   Find mid-point (M) of G and H
    let Xm = (Xg + Xh) / 2
    let Ym = (Yg + Yh) / 2
    let Zm = (Zg + Zh) / 2
    //   Length of line BM (Tangents bisector)
    let BM = ((Xm - Xb) ** 2 + (Ym - Yb) ** 2 + (Zm - Zb) ** 2) ** 0.5
    //   Direction cosines of BM
    let BMi = (Xm - Xb) / BM
    let BMj = (Ym - Yb) / BM
    let BMk = (Zm - Zb) / BM
    //   Cosine of angle ABM (Half angle ABC)
    let cosABM = (ABi * BMi) + (ABj * BMj) + (ABk * BMk)
    //   Find the shorter of AB and BC
    let Base: any;
    if (AB < BC)
        Base = AB
    else
        Base = BC
    //   Right-angled triange ABD or CBD
    let Hypotenuse = Base / cosABM
    //   Find coordinates of Bend Radius Centre
    let X_centre = Xb + (Hypotenuse * BMi)
    let Y_centre = Yb + (Hypotenuse * BMj)
    let Z_centre = Zb + (Hypotenuse * BMk)
    //   Find Bend Radius
    let Bend_Rad = (Hypotenuse ** 2 - Base ** 2) ** 0.5

    return { yaricap: Bend_Rad, cap: Bend_Rad * 2, merkez: new FikoVektor3D(X_centre, Y_centre, Z_centre), aci: null, nokta1: null, nokta2: null }
    //   Results:—
    // Cells(1, 1) = "Bend Radius": Cells(1, 2) = Bend_Rad
    // Cells(2, 1) = "X_centre   ": Cells(2, 2) = X_centre
    // Cells(3, 1) = "Y_centre   ": Cells(3, 2) = Y_centre
    // Cells(4, 1) = "Z_centre   ": Cells(4, 2) = Z_centre
    // Cells(6, 1) = "Given Points"
    // Cells(7, 1) = "Point A(x,y,z)": Cells(7, 2) = Xa
    // Cells(7, 3) = Ya: Cells(7, 4) = Za
    // Cells(8, 1) = "Point B(x,y,z)": Cells(8, 2) = Xb
    // Cells(8, 3) = Yb: Cells(8, 4) = Zb
    // Cells(9, 1) = "Point C(x,y,z)": Cells(9, 2) = Xc
    // Cells(9, 3) = Yc: Cells(9, 4) = Zc
}

/**
 * ✅ Yüzey tipi tespiti - Silindir, Küre, Düzlem vb.
 */
export const yuzeyTipiTespit = (geometry: THREE.BufferGeometry) => {
    const posAttr = geometry.attributes.position;
    if (!posAttr || posAttr.count < 3) {
        return { tip: "bilinmeyen", icerik: {} };
    }

    // ✅ CACHE CHECK - O(1) lookup
    const cached = geometryAnalysisCache.get(geometry);
    if (cached && cached.surfaceType) {  // ✅ FIX: Check surfaceType exists
        // Döndürülen tip cached surface type'ına bağlı
        let returnTip = 'egri'; // Default for curved surfaces
        if (cached.surfaceType === 'duzlem') returnTip = 'duzlem';
        else if (cached.surfaceType === 'bilinmeyen') returnTip = 'bilinmeyen';
        else if (cached.surfaceType === 'silindir' || cached.surfaceType === 'kure') returnTip = 'egri';

        return {
            tip: returnTip,
            icerik: {
                avgRadius: cached.avgRadius,
                minRadius: cached.minRadius,
                maxRadius: cached.maxRadius,
                curvature: cached.circleRMS,
                accuracy: cached.accuracy,
                tipi: cached.surfaceType,
                planarity: cached.accuracy
            }
        };
    }

    // Tüm noktaları topla
    let points: FikoVektor3D[] = [];
    for (let i = 0; i < posAttr.count; i++) {
        points.push(new FikoVektor3D(posAttr.getX(i), posAttr.getY(i), posAttr.getZ(i)));
    }

    // ✅ Cache store helper
    const cacheAndReturn = (surfaceType: string, icerik: any, avgRadius?: number, minRadius?: number, maxRadius?: number, rms?: number) => {
        const cacheEntry: CachedGeometryAnalysis = {
            surfaceType: surfaceType as any,
            accuracy: icerik.accuracy || (icerik.planarity || 0),
            avgRadius: avgRadius,
            minRadius: minRadius,
            maxRadius: maxRadius,
            circleRMS: rms,
            vertexCount: points.length,
            hashedBounds: geometry.uuid,
            timestamp: Date.now()
        };
        geometryAnalysisCache.set(geometry, cacheEntry);

        // Correct return type based on surfaceType
        let returnTip = 'egri'; // Default for curved/cylindrical/spherical
        if (surfaceType === 'duzlem') returnTip = 'duzlem';
        else if (surfaceType === 'bilinmeyen') returnTip = 'bilinmeyen';

        return { tip: returnTip, icerik };
    };

    // 1. Düzlem kontrolü
    const plane = yuzeyDuzlemAl(geometry);
    let düzlemsellik = 0;

    if (plane) {
        let düzlemselSapiCounter = 0;
        for (let i = 0; i < points.length; i++) {
            const dist = Math.abs(plane.distanceToPoint(points[i]));
            if (dist < 0.1) { // 0.1mm tolerans
                düzlemselSapiCounter++;
            }
        }
        düzlemsellik = (düzlemselSapiCounter / points.length) * 100;
    }

    // Eğer %90'dan fazla nokta düzleme yakınsa, düzlem
    if (düzlemsellik > 90) {
        const icerik = { planarity: düzlemsellik, normal: plane.normal, distance: plane.constant };
        geometryAnalysisCache.set(geometry, {
            surfaceType: 'duzlem',
            accuracy: düzlemsellik,
            vertexCount: points.length,
            hashedBounds: geometry.uuid,
            timestamp: Date.now()
        });
        return { tip: "duzlem", icerik };
    }

    // 2. Silindir kontrolü - tüm noktaların bir axis'e olan radial uzaklığı eşit mi?
    // 🎯 v3.2.11: Eşik %90'dan %70'e düşürüldü - CAD modellerinde silindirik yüzeyler çoğunlukla bu aralıkta
    const silinderTespiti = silinderKontrol(points);
    if (silinderTespiti && silinderTespiti.dogruluk > 70) { // Daha düşük accuracy - CAD uyumlu
        return cacheAndReturn("silindir", {
            avgRadius: silinderTespiti.yaricap,
            center: silinderTespiti.merkez,
            axis: silinderTespiti.axis,
            accuracy: silinderTespiti.dogruluk,
            tipi: "silindir"
        }, silinderTespiti.yaricap, undefined, undefined);
    }

    // 3. Küre kontrolü - tüm noktaların merkeze olan uzaklığı eşit mi?
    // 🎯 v3.2.11: Eşik %90'dan %70'e düşürüldü - CAD uyumlu
    const kureTespiti = kureKontrol(points);
    if (kureTespiti && kureTespiti.dogruluk > 70) { // Daha düşük accuracy - CAD uyumlu
        return cacheAndReturn("kure", {
            avgRadius: kureTespiti.yaricap,
            center: kureTespiti.merkez,
            accuracy: kureTespiti.dogruluk,
            tipi: "kure"
        }, kureTespiti.yaricap, undefined, undefined);
    }

    // 3.5. Koni kontrolü - silindir/küre değilse, eksen boyunca lineer yarıçap artışı var mı?
    const koniTespiti = koniKontrol(points);
    if (koniTespiti && koniTespiti.accuracy > 80) {
        return cacheAndReturn("koni", {
            apex: koniTespiti.apex,
            axis: koniTespiti.axis,
            angle: koniTespiti.angle,
            baseRadius: koniTespiti.baseRadius,
            accuracy: koniTespiti.accuracy,
            tipi: "koni"
        }, koniTespiti.baseRadius);
    }

    // 4. Radius/Eğri yüzey kontrolü - yüzey eğrili mi?
    // Bu, silindir ve küre olmayan durumlar için geçerli
    const egriTespiti = egriYuzeyKontrol(points);
    if (egriTespiti) {
        return cacheAndReturn("egri", {
            minRadius: egriTespiti.minRadius,
            maxRadius: egriTespiti.maxRadius,
            avgRadius: egriTespiti.avgRadius,
            curvature: egriTespiti.curvature,
            accuracy: egriTespiti.accuracy
        }, egriTespiti.avgRadius, egriTespiti.minRadius, egriTespiti.maxRadius);
    }

    // Cache bilinmeyen sonuç da
    geometryAnalysisCache.set(geometry, {
        surfaceType: 'bilinmeyen',
        accuracy: 0,
        vertexCount: points.length,
        hashedBounds: geometry.uuid,
        timestamp: Date.now()
    });

    return {
        tip: "kompleks",
        icerik: { bilgi: "Belirlenmis karmasik yuzey tipi" }
    };
};

/**
 * ✅ Robust Outlier Filtering - İstatistiksel yöntem (IQR)
 * Edge/corner noktaları filtre eder, interior points ile çalışır
 */
const filterOutliersByIQR = (points: FikoVektor3D[], centerPoint: FikoVektor3D): FikoVektor3D[] => {
    if (points.length < 10) return points; // Çok az nokta varsa filtre yapma

    // Merkezden her noktanın uzaklığını hesapla
    const distances = points.map(p => p.clone().sub(centerPoint).length());

    // Sıralı distances için IQR hesapla
    const sorted = [...distances].sort((a, b) => a - b);
    const q1Index = Math.floor(sorted.length * 0.25);
    const q3Index = Math.floor(sorted.length * 0.75);
    const q1 = sorted[q1Index];
    const q3 = sorted[q3Index];
    const iqr = q3 - q1;

    // IQR-based bounds
    const lowerBound = q1 - 1.5 * iqr;
    const upperBound = q3 + 1.5 * iqr;

    // Outliers'ı filtre et
    const filtered: FikoVektor3D[] = [];
    let outlierCount = 0;

    for (let i = 0; i < points.length; i++) {
        if (distances[i] >= lowerBound && distances[i] <= upperBound) {
            filtered.push(points[i]);
        } else {
            outlierCount++;
        }
    }

    return filtered.length >= 5 ? filtered : points; // En az 5 nokta kalsın
};

/**
 * ✅ Silindir tespiti - LEAST-SQUARES CROSS-SECTION FITTING
 * Her cross-section'da circle fitting yaparak en doğru radiüs hesaplama
 * Outliers filtrelenerek robust fitting yapılır
 */
const silinderKontrol = (points: FikoVektor3D[]): any => {
    if (points.length < 5) return null;

    // ✅ Outliers'ı filtre et - edge/corner noktaları kaldır
    const initialCenter = new FikoVektor3D(0, 0, 0);
    for (let p of points) {
        initialCenter.add(p);
    }
    initialCenter.divideScalar(points.length);

    const filteredPoints = filterOutliersByIQR(points, initialCenter);

    // Centroid hesapla (filtered points ile)
    let center = new FikoVektor3D(0, 0, 0);
    for (let p of filteredPoints) {
        center.add(p);
    }
    center.divideScalar(filteredPoints.length);

    // Kovaryans matrisi hesapla (PCA için)
    let cov = [
        [0, 0, 0],
        [0, 0, 0],
        [0, 0, 0]
    ];

    for (let p of filteredPoints) {
        const v = p.clone().sub(center);
        cov[0][0] += v.x * v.x;
        cov[0][1] += v.x * v.y;
        cov[0][2] += v.x * v.z;
        cov[1][1] += v.y * v.y;
        cov[1][2] += v.y * v.z;
        cov[2][2] += v.z * v.z;
    }

    cov[1][0] = cov[0][1];
    cov[2][0] = cov[0][2];
    cov[2][1] = cov[1][2];

    // PCA ile axis bulma - En büyük varyans yönü (silindir ekseni)
    let axis = new FikoVektor3D(1, 1, 1).normalize();

    for (let iter = 0; iter < 20; iter++) {
        let newAxis = new FikoVektor3D(0, 0, 0);
        newAxis.x = cov[0][0] * axis.x + cov[0][1] * axis.y + cov[0][2] * axis.z;
        newAxis.y = cov[1][0] * axis.x + cov[1][1] * axis.y + cov[1][2] * axis.z;
        newAxis.z = cov[2][0] * axis.x + cov[2][1] * axis.y + cov[2][2] * axis.z;

        const len = newAxis.length();
        if (len < 0.0001) break;

        newAxis.divideScalar(len);
        axis = newAxis;
    }

    if (axis.length() < 0.001) {
        axis = new FikoVektor3D(0, 0, 1);
    }
    axis.normalize();

    // ✅ ITERATIVE FITTING WITH LEAST-SQUARES CROSS-SECTIONS
    // Her iterasyonda, cross-section'ları ayırıp her birinde least-squares circle fitting yapacağız
    let optimizedCenter = center.clone();
    let avgRadius = 0;

    for (let iteration = 0; iteration < 5; iteration++) {
        // Cross-section'ları axial yönde grupla (10 slice)
        let radiuses: number[] = [];
        let radiusSum = 0;
        const sliceCount = Math.max(3, Math.min(10, Math.floor(filteredPoints.length / 10)));

        // Axial projeksiyonlara göre min/max bul
        let minAxial = Infinity;
        let maxAxial = -Infinity;
        const projections: { axial: number; point: FikoVektor3D }[] = [];

        for (let p of filteredPoints) {
            const toPoint = p.clone().sub(optimizedCenter);
            const axialProj = toPoint.dot(axis);
            minAxial = Math.min(minAxial, axialProj);
            maxAxial = Math.max(maxAxial, axialProj);
            projections.push({ axial: axialProj, point: p });
        }

        const axialRange = maxAxial - minAxial;
        let sliceRadiuses: number[] = [];

        // Her slice için circle fitting yap
        for (let slice = 0; slice < sliceCount; slice++) {
            const sliceMin = minAxial + (slice / sliceCount) * axialRange;
            const sliceMax = minAxial + ((slice + 1) / sliceCount) * axialRange;

            // Bu slice'daki noktaları bul
            const slicePoints = projections
                .filter(p => p.axial >= sliceMin && p.axial <= sliceMax)
                .map(p => p.point);

            if (slicePoints.length < 3) continue;

            // Cross-section noktalarını silindir ekseninden çıkar (2D hale getir)
            const crossSectionPoints: FikoVektor3D[] = [];
            for (let sp of slicePoints) {
                const toPoint = sp.clone().sub(optimizedCenter);
                const axialProj = toPoint.dot(axis);
                // Radial vektör = noktanın axis component'ini çıkar
                const radialVec = toPoint.clone().sub(axis.clone().multiplyScalar(axialProj));
                crossSectionPoints.push(radialVec);
            }

            // Least-squares circle fitting bu cross-section için
            // (merkez zaten axis üzerine yani [0,0,0] olduğunu varsay 2D'de)
            let sliceRadius = 0;
            let radiusCount = 0;

            for (let sp of crossSectionPoints) {
                sliceRadius += sp.length();
                radiusCount++;
            }

            if (radiusCount > 0) {
                sliceRadius /= radiusCount;
                sliceRadiuses.push(sliceRadius);
                radiusSum += sliceRadius;
            }
        }

        // Slice'lardan ortalama radiüs hesapla
        if (sliceRadiuses.length > 0) {
            avgRadius = radiusSum / sliceRadiuses.length;
        } else {
            // Fallback: tüm noktalarla radial mesafe hesapla
            for (let p of points) {
                const toPoint = p.clone().sub(optimizedCenter);
                const radialDist = toPoint.clone().sub(axis.clone().multiplyScalar(toPoint.dot(axis))).length();
                radiuses.push(radialDist);
                radiusSum += radialDist;
            }
            avgRadius = radiusSum / filteredPoints.length;
        }

        // Radial yönde merkezi ayarla
        let radialCenterCorrection = new FikoVektor3D(0, 0, 0);

        for (let p of filteredPoints) {
            const toPoint = p.clone().sub(optimizedCenter);
            const axialProj = toPoint.dot(axis);
            const radialVec = toPoint.clone().sub(axis.clone().multiplyScalar(axialProj));
            const radialDist = radialVec.length();

            if (radialDist > 0.0001) {
                const radialUnit = radialVec.clone().divideScalar(radialDist);
                const correction = radialUnit.multiplyScalar(avgRadius - radialDist);
                radialCenterCorrection.add(correction);
            }
        }

        radialCenterCorrection.divideScalar(filteredPoints.length);
        optimizedCenter.add(radialCenterCorrection);

        if (radialCenterCorrection.length() < 0.001) break;
    }

    // Final radius hesaplama - filtered noktalarla
    let radiuses: number[] = [];
    let radiusSum = 0;

    for (let p of filteredPoints) {
        const toPoint = p.clone().sub(optimizedCenter);
        const radialDist = toPoint.clone().sub(axis.clone().multiplyScalar(toPoint.dot(axis))).length();
        radiuses.push(radialDist);
        radiusSum += radialDist;
    }

    avgRadius = radiusSum / filteredPoints.length;

    // ✅ Guard against empty radiuses array (all points filtered as outliers)
    if (radiuses.length === 0) {
        return null;
    }

    // Dinamik tolerans
    const tolerance = Math.max(0.1, avgRadius * 0.05);

    // Sapma istatistikleri
    let deviationCount = 0;
    let deviationSum = 0;
    let maxDeviation = 0;

    for (let r of radiuses) {
        const dev = Math.abs(r - avgRadius);
        deviationSum += dev;
        if (dev > maxDeviation) maxDeviation = dev;
        if (dev > tolerance) {
            deviationCount++;
        }
    }

    const avgDeviation = deviationSum / points.length;
    const dogruluk = ((points.length - deviationCount) / points.length) * 100;

    if (dogruluk > 85 && maxDeviation < avgRadius * 0.15) {
        return {
            yaricap: avgRadius,
            merkez: optimizedCenter,
            axis: axis,
            dogruluk: dogruluk,
            avgDeviation: avgDeviation,
            maxDeviation: maxDeviation
        };
    }

    return null;
};

/**
 * ✅ Koni tespiti - CPU (GPU detectCone fallback'i)
 *
 * Yöntem: PCA ile eksen (koni elongasyon yönü), sonra eksen boyunca dilimlerin
 * yarıçapı ile eksenel konum arasında LİNEER regresyon. Silindirde eğim ~0,
 * konide eğim = tan(yarımAçı). Normal gerekmez; silindirden ayırır.
 * Dönen şekil GPU detectCone ile aynı (apex, axis, angle°, accuracy, tipi:'koni').
 */
const koniKontrol = (points: FikoVektor3D[]): any => {
    if (points.length < 8) return null;

    // Centroid + outlier filtre
    const initialCenter = new FikoVektor3D(0, 0, 0);
    for (let p of points) initialCenter.add(p);
    initialCenter.divideScalar(points.length);
    const fp = filterOutliersByIQR(points, initialCenter);
    if (fp.length < 8) return null;

    const center = new FikoVektor3D(0, 0, 0);
    for (let p of fp) center.add(p);
    center.divideScalar(fp.length);

    // PCA kovaryans → en büyük varyans yönü = koni ekseni (power iteration)
    const cov = [[0, 0, 0], [0, 0, 0], [0, 0, 0]];
    for (let p of fp) {
        const v = p.clone().sub(center);
        cov[0][0] += v.x * v.x; cov[0][1] += v.x * v.y; cov[0][2] += v.x * v.z;
        cov[1][1] += v.y * v.y; cov[1][2] += v.y * v.z; cov[2][2] += v.z * v.z;
    }
    cov[1][0] = cov[0][1]; cov[2][0] = cov[0][2]; cov[2][1] = cov[1][2];

    let axis = new FikoVektor3D(1, 1, 1).normalize();
    for (let iter = 0; iter < 20; iter++) {
        const na = new FikoVektor3D(0, 0, 0);
        na.x = cov[0][0] * axis.x + cov[0][1] * axis.y + cov[0][2] * axis.z;
        na.y = cov[1][0] * axis.x + cov[1][1] * axis.y + cov[1][2] * axis.z;
        na.z = cov[2][0] * axis.x + cov[2][1] * axis.y + cov[2][2] * axis.z;
        const len = na.length();
        if (len < 0.0001) break;
        na.divideScalar(len);
        axis = na;
    }
    axis.normalize();

    // Her nokta için eksenel (t) ve radyal (ρ) bileşen
    let minAxial = Infinity, maxAxial = -Infinity;
    const proj: { t: number; r: number }[] = [];
    for (let p of fp) {
        const toP = p.clone().sub(center);
        const t = toP.dot(axis);
        const r = toP.clone().sub(axis.clone().multiplyScalar(t)).length();
        proj.push({ t, r });
        if (t < minAxial) minAxial = t;
        if (t > maxAxial) maxAxial = t;
    }
    const axialRange = maxAxial - minAxial;
    if (axialRange < 1e-4) return null;

    // Dilimlerde ortalama (t, ρ) örnekleri → gürültüyü azalt
    const sliceCount = Math.max(4, Math.min(12, Math.floor(fp.length / 8)));
    const sliceT: number[] = new Array(sliceCount).fill(0);
    const sliceR: number[] = new Array(sliceCount).fill(0);
    const sliceN: number[] = new Array(sliceCount).fill(0);
    for (const pr of proj) {
        let s = Math.floor(((pr.t - minAxial) / axialRange) * sliceCount);
        if (s >= sliceCount) s = sliceCount - 1;
        sliceT[s] += pr.t; sliceR[s] += pr.r; sliceN[s]++;
    }
    const ts: number[] = [], rs: number[] = [];
    for (let s = 0; s < sliceCount; s++) {
        if (sliceN[s] > 0) { ts.push(sliceT[s] / sliceN[s]); rs.push(sliceR[s] / sliceN[s]); }
    }
    if (ts.length < 3) return null;

    // Lineer regresyon r = m·t + b
    const n = ts.length;
    let sT = 0, sR = 0, sTT = 0, sTR = 0;
    for (let i = 0; i < n; i++) { sT += ts[i]; sR += rs[i]; sTT += ts[i] * ts[i]; sTR += ts[i] * rs[i]; }
    const denom = n * sTT - sT * sT;
    if (Math.abs(denom) < 1e-9) return null;
    const m = (n * sTR - sT * sR) / denom;
    const b = (sR - m * sT) / n;

    const halfAngle = Math.atan(Math.abs(m));
    // Silindire çok yakın (düz) veya dejenere → koni değil
    if (halfAngle < 0.03 || halfAngle > 1.5) return null;

    // Apex (r=0): t0 = -b/m
    const t0 = -b / m;
    const apex = center.clone().add(axis.clone().multiplyScalar(t0));

    // baseRadius: en uzak eksenel uçtaki yarıçap
    const tFar = Math.abs(maxAxial - t0) > Math.abs(minAxial - t0) ? maxAxial : minAxial;
    const baseRadius = Math.abs(m) * Math.abs(tFar - t0);

    // Doğruluk: dilim ρ'larının regresyon doğrusuna uyumu
    let maxErr = 0;
    for (let i = 0; i < n; i++) {
        const beklenen = m * ts[i] + b;
        maxErr = Math.max(maxErr, Math.abs(rs[i] - beklenen) / Math.max(baseRadius, 1e-6));
    }
    const dogruluk = Math.max(0, 100 - maxErr * 800);
    if (dogruluk < 80) return null;

    return {
        apex,
        axis,
        angle: halfAngle * 180 / Math.PI, // yarım açı (derece) - GPU ile uyumlu
        baseRadius,
        accuracy: dogruluk
    };
};

/**
 * ✅ Küre tespiti - Geliştirilmiş versiyon
 * Iterative fit kullanarak merkez ve yarıçap bulma
 */
const kureKontrol = (points: FikoVektor3D[]): any => {
    if (points.length < 4) return null;

    // İlk merkez tahmini: centroid
    let initialCenter = new FikoVektor3D(0, 0, 0);
    for (let p of points) {
        initialCenter.add(p);
    }
    initialCenter.divideScalar(points.length);

    // ✅ Outliers'ı filtre et
    const filteredPoints = filterOutliersByIQR(points, initialCenter);

    // ✅ Guard against empty filteredPoints (all points filtered as outliers)
    if (filteredPoints.length === 0) {
        return null;
    }

    let center = new FikoVektor3D(0, 0, 0);
    for (let p of filteredPoints) {
        center.add(p);
    }
    center.divideScalar(filteredPoints.length);

    // Iterative refinement (Gauss-Newton gibi basit)
    let radiuses: number[] = [];
    let radiusSum = 0;

    for (let p of filteredPoints) {
        const dist = p.clone().sub(center).length();
        radiuses.push(dist);
        radiusSum += dist;
    }

    const avgRadius = radiusSum / filteredPoints.length;

    // Dinamik tolerans: ortalama radiüsün %5'i veya 0.1mm, hangisi daha büyükse
    const tolerance = Math.max(0.1, avgRadius * 0.05);

    // Sapma istatistikleri
    let deviationCount = 0;
    let deviationSum = 0;
    let maxDeviation = 0;

    for (let r of radiuses) {
        const dev = Math.abs(r - avgRadius);
        deviationSum += dev;
        if (dev > maxDeviation) maxDeviation = dev;
        if (dev > tolerance) {
            deviationCount++;
        }
    }

    const avgDeviation = deviationSum / points.length;
    const dogruluk = ((points.length - deviationCount) / points.length) * 100;

    // %85'den fazla uyumluysa küre (yüksek eşik)
    // Ek koşul: maxDeviation radiüsün %15'ini aşmamalı
    if (dogruluk > 85 && maxDeviation < avgRadius * 0.15) {
        return {
            yaricap: avgRadius,
            merkez: center,
            dogruluk: dogruluk,
            avgDeviation: avgDeviation,
            maxDeviation: maxDeviation
        };
    }

    return null;
}

/**
 * ✅ Eğri/Radius Yüzey tespiti - Catia/FreeCAD uyumlu
 * Silindir ve Küre düşük accuracy ile bulunmazsa, eğri yüzey olarak işaretler
 * Çift axis test ve robust merkez hesaplama
 */
const egriYuzeyKontrol = (points: FikoVektor3D[]): any => {
    if (points.length < 6) return null;

    // Centroid hesapla
    let initialCenter = new FikoVektor3D(0, 0, 0);
    for (let p of points) {
        initialCenter.add(p);
    }
    initialCenter.divideScalar(points.length);

    // ✅ Outliers'ı filtre et - robust fitting için
    const filteredPoints = filterOutliersByIQR(points, initialCenter);

    // ✅ Guard against empty filteredPoints (all points filtered as outliers)
    if (filteredPoints.length === 0) {
        return null;
    }

    let center = new FikoVektor3D(0, 0, 0);
    for (let p of filteredPoints) {
        center.add(p);
    }
    center.divideScalar(filteredPoints.length);

    // ✅ PCA ile axis bulma (silinderKontrol ile aynı)
    let cov = [
        [0, 0, 0],
        [0, 0, 0],
        [0, 0, 0]
    ];

    for (let p of filteredPoints) {
        const v = p.clone().sub(center);
        cov[0][0] += v.x * v.x;
        cov[0][1] += v.x * v.y;
        cov[0][2] += v.x * v.z;
        cov[1][1] += v.y * v.y;
        cov[1][2] += v.y * v.z;
        cov[2][2] += v.z * v.z;
    }

    cov[1][0] = cov[0][1];
    cov[2][0] = cov[0][2];
    cov[2][1] = cov[1][2];

    // Power iteration ile dominant eigenvector
    let bestAxis = new FikoVektor3D(1, 1, 1).normalize();

    for (let iter = 0; iter < 20; iter++) {
        let newAxis = new FikoVektor3D(0, 0, 0);
        newAxis.x = cov[0][0] * bestAxis.x + cov[0][1] * bestAxis.y + cov[0][2] * bestAxis.z;
        newAxis.y = cov[1][0] * bestAxis.x + cov[1][1] * bestAxis.y + cov[1][2] * bestAxis.z;
        newAxis.z = cov[2][0] * bestAxis.x + cov[2][1] * bestAxis.y + cov[2][2] * bestAxis.z;

        const len = newAxis.length();
        if (len < 0.0001) break;

        newAxis.divideScalar(len);
        bestAxis = newAxis;
    }

    if (bestAxis.length() < 0.001) {
        bestAxis = null;
    } else {
        bestAxis.normalize();
    }

    // ===== CENTER-BASED TEST (torus/radiüs yüzeyleri için) =====
    let centerBasedRadiuses: number[] = [];
    let radiusSum = 0;

    for (let p of filteredPoints) {
        const dist = p.clone().sub(center).length();
        centerBasedRadiuses.push(dist);
        radiusSum += dist;
    }

    const centerAvgRadius = radiusSum / centerBasedRadiuses.length;
    // 🔧 FIX: Math.max/min spread overflow için loop kullan (büyük array'lerde stack overflow önlenir)
    let centerMax = -Infinity, centerMin = Infinity;
    for (let i = 0; i < centerBasedRadiuses.length; i++) {
        if (centerBasedRadiuses[i] > centerMax) centerMax = centerBasedRadiuses[i];
        if (centerBasedRadiuses[i] < centerMin) centerMin = centerBasedRadiuses[i];
    }
    const centerVariation = centerMax - centerMin;

    // ===== EN UYGUN YÖNTEMİ SEÇ =====
    let radiuses: number[];
    let useAxis = false;
    let selectedMethod = "center";

    if (bestAxis) {
        // ✅ Iterative fitting ile axis-based radiusları hesapla
        let optimizedCenter = center.clone();
        let axisAvgRadius = 0;

        // 5 iterasyon ile merkez ve radius optimize et
        for (let iteration = 0; iteration < 5; iteration++) {
            let axisRadiuses: number[] = [];
            let axisRadiusSum = 0;

            for (let p of filteredPoints) {
                const toPoint = p.clone().sub(optimizedCenter);
                const axialProj = toPoint.dot(bestAxis);
                const radialVec = toPoint.clone().sub(bestAxis.clone().multiplyScalar(axialProj));
                const radialDist = radialVec.length();
                axisRadiuses.push(radialDist);
                axisRadiusSum += radialDist;
            }

            axisAvgRadius = axisRadiusSum / axisRadiuses.length;

            // Merkezi radial yönde düzelt
            let radialCenterCorrection = new FikoVektor3D(0, 0, 0);

            for (let p of filteredPoints) {
                const toPoint = p.clone().sub(optimizedCenter);
                const axialProj = toPoint.dot(bestAxis);
                const radialVec = toPoint.clone().sub(bestAxis.clone().multiplyScalar(axialProj));
                const radialDist = radialVec.length();

                if (radialDist > 0.0001) {
                    const radialUnit = radialVec.clone().divideScalar(radialDist);
                    const correction = radialUnit.multiplyScalar(axisAvgRadius - radialDist);
                    radialCenterCorrection.add(correction);
                }
            }

            radialCenterCorrection.divideScalar(filteredPoints.length);
            optimizedCenter.add(radialCenterCorrection);

            if (radialCenterCorrection.length() < 0.001) break;
        }

        // Final axis-based radiuslar
        let axisRadiuses: number[] = [];
        for (let p of filteredPoints) {
            const toPoint = p.clone().sub(optimizedCenter);
            const radialDist = toPoint.clone().sub(bestAxis.clone().multiplyScalar(toPoint.dot(bestAxis))).length();
            axisRadiuses.push(radialDist);
        }

        // 🔧 FIX: Math.max/min spread overflow için loop kullan
        let axisMax = -Infinity, axisMin = Infinity;
        for (let i = 0; i < axisRadiuses.length; i++) {
            if (axisRadiuses[i] > axisMax) axisMax = axisRadiuses[i];
            if (axisRadiuses[i] < axisMin) axisMin = axisRadiuses[i];
        }
        const axisVariation = axisMax - axisMin;

        // Daha düşük varyasyona sahip olanı seç
        if (axisVariation < centerVariation * 0.8) { // Axis en az %20 daha iyi ise kullan
            radiuses = axisRadiuses;
            useAxis = true;
            selectedMethod = "axis";
        } else {
            radiuses = centerBasedRadiuses;
        }
    } else {
        radiuses = centerBasedRadiuses;
    }

    // ===== RADIUS İSTATİSTİKLERİ =====
    const radiusSum_final = radiuses.reduce((a, b) => a + b, 0);
    const avgRadius = radiusSum_final / radiuses.length;

    radiuses.sort((a, b) => a - b);
    const minRadius = radiuses[0];
    const maxRadius = radiuses[radiuses.length - 1];
    const radiusVariation = maxRadius - minRadius;
    const radiusVariationRatio = avgRadius > 0.001 ? (radiusVariation / avgRadius) * 100 : 0;

    // ===== SAPMA İSTATİSTİKLERİ =====
    let deviationSum = 0;
    let maxDeviation = 0;
    for (let r of radiuses) {
        const dev = Math.abs(r - avgRadius);
        deviationSum += dev;
        if (dev > maxDeviation) maxDeviation = dev;
    }
    const avgDeviation = deviationSum / radiuses.length;

    // ===== EĞRI YÜZEY KARARI =====
    // 🎯 v3.2.11: Alt sınır %2'den %0'a düşürüldü - mükemmel silindir/küre de "egri" olarak algılansın
    // CAD silindirik yüzeyleri çoğu zaman çok düşük variation gösterir
    // Catia/FreeCAD uyumlu: %0 ile %120 arasında radiüs değişimi = eğri yüzey
    if (radiusVariationRatio >= 0 && radiusVariationRatio < 120 && avgRadius > 0.01) {
        // Curvature metriği: ortalama deviation
        const accuracy = Math.max(0, 100 - radiusVariationRatio);

        return {
            minRadius: minRadius,
            maxRadius: maxRadius,
            avgRadius: avgRadius,
            curvature: avgDeviation,
            accuracy: parseFloat(accuracy.toFixed(2)),
            radiusVariation: parseFloat(radiusVariationRatio.toFixed(2)),
            useAxis: useAxis,
            method: selectedMethod,
            avgDeviation: avgDeviation,
            maxDeviation: maxDeviation
        };
    }

    return null;
}

/**
 * ✅ Çizgi eğriliği tespiti - çizgi kavisli mi düz mü?
 */
export const cizgiEgrilikiTespit = (geometry: THREE.BufferGeometry) => {
    const posAttr = geometry.attributes.position;
    if (!posAttr || posAttr.count < 4) {
        return null; // Eğrilik tespiti için en az 4 nokta gerek
    }

    let points: FikoVektor3D[] = [];
    for (let i = 0; i < posAttr.count; i++) {
        points.push(new FikoVektor3D(posAttr.getX(i), posAttr.getY(i), posAttr.getZ(i)));
    }

    // 1. Çizginin başından sonuna vektör
    const basla = points[0];
    const bitir = points[points.length - 1];
    const ucsuzVektor = bitir.clone().sub(basla);
    const mesafe = ucsuzVektor.length();

    if (mesafe < 0.001) return null; // Başla-bitir aynı nokta

    // 2. Her noktanın başlangıç-bitiş çizgisinden ne kadar uzak olduğunu ölç
    // 🔴 BUGFIX: Başlangıç ve bitiş noktalarını da dahil et
    let maxSapma = 0;
    let toplamSapma = 0;

    for (let i = 0; i < points.length; i++) {
        const nokta = points[i];
        // Noktanın başlangıç-bitiş çizgisine olan perpendicular uzaklığı
        const baslaDanVektor = nokta.clone().sub(basla);

        // Projection: baslaDanVektor'ün ucsuzVektor'e projeksiyonu
        const t = baslaDanVektor.dot(ucsuzVektor) / (mesafe * mesafe);

        // Clamp t between 0 and 1
        const tClamped = Math.max(0, Math.min(1, t));

        // Çizgi üzerindeki nokta
        const cizgiNoktasi = basla.clone().add(ucsuzVektor.clone().multiplyScalar(tClamped));

        // Uzaklık
        const sapma = nokta.clone().sub(cizgiNoktasi).length();
        toplamSapma += sapma;
        if (sapma > maxSapma) {
            maxSapma = sapma;
        }
    }

    const ortaSapma = toplamSapma / points.length;

    // 3. Eğrilik derecesi hesapla
    // Çizgi tamamı uzunluğu (segmentler toplamı)
    let cizgiUzunlugu = 0;
    for (let i = 1; i < points.length; i++) {
        const seg = points[i].clone().sub(points[i - 1]);
        cizgiUzunlugu += seg.length();
    }

    // Eğrilik oranı = (Gerçek uzunluk - Düz uzunluk) / Düz uzunluk
    const egriliBilim = (cizgiUzunlugu - mesafe) / mesafe;

    // 4. Ortalama eğrilik açısı
    let toplamAci = 0;
    let aciSayisi = 0;

    for (let i = 1; i < points.length - 1; i++) {
        const v1 = points[i].clone().sub(points[i - 1]).normalize();
        const v2 = points[i + 1].clone().sub(points[i]).normalize();

        // Açı hesapla
        const dotProd = Math.max(-1, Math.min(1, v1.dot(v2)));
        const aci = Math.acos(dotProd) * (180 / Math.PI);
        toplamAci += aci;
        aciSayisi++;
    }

    const ortaAci = aciSayisi > 0 ? toplamAci / aciSayisi : 0;

    // Eğrilik kontrolü:
    // - Düz çizgi: sapma < 0.1mm, eğrilik < %1
    // - Hafif eğri: sapma 0.1-1mm, eğrilik %1-10
    // - Çok eğri: sapma > 1mm, eğrilik > %10

    let egrilikTipi = "duz";
    if (egriliBilim > 0.1 || maxSapma > 1) {
        egrilikTipi = "cok-egri";
    } else if (egriliBilim > 0.01 || maxSapma > 0.1) {
        egrilikTipi = "hafif-egri";
    }

    return {
        tipi: egrilikTipi,
        egriliBilim: (egriliBilim * 100).toFixed(2) + "%",
        maxSapma: maxSapma.toFixed(4),
        ortaSapma: ortaSapma.toFixed(4),
        ortaAci: ortaAci.toFixed(2),
        gercekUzunluk: cizgiUzunlugu.toFixed(4),
        duzUzunluk: mesafe.toFixed(4)
    };
}

/**
 * ✅ Min/Max/Ortalama Hesaplama - Ölçüm geçmişinden
 * @param olcumGecmisi Ölçüm geçmişi array'i
 * @param aciklamaSivrimi Aranacak açıklama
 * @returns Min, Max, Ortalama değerleri
 */
export const hesaplaMinMaxOrtalama = (
    olcumGecmisi: Array<{ aciklama: string, olcu: number, birim: string }>,
    aciklamaSivrimi: string
): { min: number, max: number, ortalama: number } | null => {
    const eslesiyor = olcumGecmisi.filter(o => o.aciklama.includes(aciklamaSivrimi));

    if (eslesiyor.length === 0) return null;

    const degerler = eslesiyor.map(o => o.olcu);
    // 🔧 FIX: Math.min/max spread overflow için loop kullan
    let min = degerler[0], max = degerler[0];
    for (let i = 1; i < degerler.length; i++) {
        if (degerler[i] < min) min = degerler[i];
        if (degerler[i] > max) max = degerler[i];
    }
    const ortalama = degerler.reduce((a, b) => a + b, 0) / degerler.length;

    return { min, max, ortalama };
}

/**
 * ✅ Tolerans Kontrol - Ölçüm tolerans aralığı hesapla
 * @param olcu Ölçülen değer
 * @param tolerans Tolerans değeri
 * @returns Tolerans min/max aralığı ve mesaj
 */
export const toleransKontrol = (
    olcu: number,
    tolerans: number
): { uygun: boolean, mesaj: string, toleransMin: number, toleransMax: number } => {
    const toleransMin = olcu - tolerans;
    const toleransMax = olcu + tolerans;

    return {
        uygun: true, // Her zaman uygun (kontrolü template'de yapabiliriz)
        mesaj: `${toleransMin.toFixed(4)} ~ ${toleransMax.toFixed(4)}`,
        toleransMin: toleransMin,
        toleransMax: toleransMax
    };
}

/**
 * ✅ Normal Vektörden Plane Geometry Oluştur
 * Normal vektöre dik bir düzlem oluşturarak visualizasyon için geometry döndür
 * @param normal Normal vektörü
 * @param point Düzlemin merkez noktası
 * @param size Düzlemin boyutu (mm)
 * @returns THREE.BufferGeometry - Düzlem geometrisi
 */
export const normalDanPlaneGeometriOlustur = (
    normal: THREE.Vector3,
    point: THREE.Vector3,
    size: number
): THREE.BufferGeometry => {
    // Normal vektöre dik iki vektör hesapla
    const up = new THREE.Vector3(0, 1, 0);
    if (Math.abs(normal.dot(up)) > 0.99) {
        up.set(1, 0, 0);
    }

    const right = new THREE.Vector3().crossVectors(normal, up).normalize();
    const forwards = new THREE.Vector3().crossVectors(right, normal).normalize();

    // Düzlem köşelerini oluştur
    const halfSize = size / 2;
    const vertices = new Float32Array([
        point.x - right.x * halfSize - forwards.x * halfSize,
        point.y - right.y * halfSize - forwards.y * halfSize,
        point.z - right.z * halfSize - forwards.z * halfSize,

        point.x + right.x * halfSize - forwards.x * halfSize,
        point.y + right.y * halfSize - forwards.y * halfSize,
        point.z + right.z * halfSize - forwards.z * halfSize,

        point.x + right.x * halfSize + forwards.x * halfSize,
        point.y + right.y * halfSize + forwards.y * halfSize,
        point.z + right.z * halfSize + forwards.z * halfSize,

        point.x - right.x * halfSize + forwards.x * halfSize,
        point.y - right.y * halfSize + forwards.y * halfSize,
        point.z - right.z * halfSize + forwards.z * halfSize,
    ]);

    const geometry = new THREE.BufferGeometry();
    geometry.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
    geometry.setIndex(new THREE.BufferAttribute(new Uint32Array([0, 1, 2, 0, 2, 3]), 1));

    return geometry;
}

// ✅ PROJECTION FONKSİYONLARI - CAD Gibi Ölçüm

export const alCizgiProjeNokta = (cizgiGeometry: THREE.BufferGeometry, nokta: THREE.Vector3) => {
    let minMesafe = Infinity;
    let projeNokta = new THREE.Vector3();
    const pos = cizgiGeometry.attributes['position'];
    for (let i = 0; i < pos.count - 1; i++) {
        const p1 = new THREE.Vector3(pos.getX(i), pos.getY(i), pos.getZ(i));
        const p2 = new THREE.Vector3(pos.getX(i + 1), pos.getY(i + 1), pos.getZ(i + 1));
        const line = new THREE.Line3(p1, p2);
        const projePoint = new THREE.Vector3();
        line.closestPointToPoint(nokta, true, projePoint);
        const mesafe = nokta.distanceTo(projePoint);
        if (mesafe < minMesafe) {
            minMesafe = mesafe;
            projeNokta.copy(projePoint);
        }
    }
    return { nokta: projeNokta, mesafe: minMesafe };
}

export const alYuzeyProjeNokta = (yuzeyGeometry: THREE.BufferGeometry, nokta: THREE.Vector3) => {
    const pos = yuzeyGeometry.attributes['position'];
    const p1 = new THREE.Vector3(pos.getX(0), pos.getY(0), pos.getZ(0));
    const p2 = new THREE.Vector3(pos.getX(1), pos.getY(1), pos.getZ(1));
    const p3 = new THREE.Vector3(pos.getX(2), pos.getY(2), pos.getZ(2));
    const v1 = new THREE.Vector3().subVectors(p2, p1);
    const v2 = new THREE.Vector3().subVectors(p3, p1);
    const normal = new THREE.Vector3().crossVectors(v1, v2).normalize();
    const vectorToPoint = new THREE.Vector3().subVectors(nokta, p1);
    const distance = vectorToPoint.dot(normal);
    const projeNokta = new THREE.Vector3().subVectors(nokta, normal.clone().multiplyScalar(distance));
    return { nokta: projeNokta, mesafe: Math.abs(distance), normal };
}

export const alYuzeyNormal = (yuzeyGeometry: THREE.BufferGeometry) => {
    const pos = yuzeyGeometry.attributes['position'];
    const p1 = new THREE.Vector3(pos.getX(0), pos.getY(0), pos.getZ(0));
    const p2 = new THREE.Vector3(pos.getX(1), pos.getY(1), pos.getZ(1));
    const p3 = new THREE.Vector3(pos.getX(2), pos.getY(2), pos.getZ(2));
    const v1 = new THREE.Vector3().subVectors(p2, p1);
    const v2 = new THREE.Vector3().subVectors(p3, p1);
    const normal = new THREE.Vector3().crossVectors(v1, v2).normalize();
    return normal;
}

export const alIkiCizgiEnKisaMesafe = (cizgi1Geometry: THREE.BufferGeometry, cizgi2Geometry: THREE.BufferGeometry) => {
    let minMesafe = Infinity;
    let nokta1 = new THREE.Vector3();
    let nokta2 = new THREE.Vector3();
    const pos1 = cizgi1Geometry.attributes['position'];
    const pos2 = cizgi2Geometry.attributes['position'];
    for (let i = 0; i < pos1.count - 1; i++) {
        const p1Start = new THREE.Vector3(pos1.getX(i), pos1.getY(i), pos1.getZ(i));
        const p1End = new THREE.Vector3(pos1.getX(i + 1), pos1.getY(i + 1), pos1.getZ(i + 1));
        for (let j = 0; j < pos2.count - 1; j++) {
            const p2Start = new THREE.Vector3(pos2.getX(j), pos2.getY(j), pos2.getZ(j));
            const p2End = new THREE.Vector3(pos2.getX(j + 1), pos2.getY(j + 1), pos2.getZ(j + 1));
            const diff = new THREE.Vector3().subVectors(p2Start, p1Start);
            const dir1 = new THREE.Vector3().subVectors(p1End, p1Start).normalize();
            const dir2 = new THREE.Vector3().subVectors(p2End, p2Start).normalize();
            const cross = new THREE.Vector3().crossVectors(dir1, dir2);
            const mesafe = Math.abs(diff.dot(cross)) / Math.max(cross.length(), 0.0001);
            if (mesafe < minMesafe) {
                minMesafe = mesafe;
                nokta1.copy(p1Start).addScaledVector(dir1, diff.dot(dir1));
                nokta2.copy(p2Start).addScaledVector(dir2, diff.dot(dir2));
            }
        }
    }
    return { nokta1, nokta2, mesafe: minMesafe };
}

/**
 * 🚀 GPU-ACCELERATED: Yüzey tipi tespiti - Async versiyon
 * WebGPU varsa 10-50x hızlanma sağlar
 * @param geometry THREE.BufferGeometry
 * @returns Promise<{ tip: string, icerik: any }>
 */
export const yuzeyTipiTespitGPU = async (geometry: THREE.BufferGeometry): Promise<{
    tip: string;
    icerik: any;
}> => {
    const posAttr = geometry.attributes.position;
    if (!posAttr || posAttr.count < 4) {
        return { tip: "bilinmeyen", icerik: {} };
    }

    // ✅ CACHE CHECK - O(1) lookup
    const cached = geometryAnalysisCache.get(geometry);
    if (cached && cached.surfaceType) {
        let returnTip = 'egri';
        if (cached.surfaceType === 'duzlem') returnTip = 'duzlem';
        else if (cached.surfaceType === 'bilinmeyen') returnTip = 'bilinmeyen';
        else if (cached.surfaceType === 'silindir' || cached.surfaceType === 'kure') returnTip = 'egri';

        return {
            tip: returnTip,
            icerik: {
                avgRadius: cached.avgRadius,
                minRadius: cached.minRadius,
                maxRadius: cached.maxRadius,
                curvature: cached.circleRMS,
                accuracy: cached.accuracy,
                tipi: cached.surfaceType,
                planarity: cached.accuracy
            }
        };
    }

    // 🚀 GPU Küre tespiti dene (en hızlı)
    try {
        const gpuSphereResult = await gpuOlcumMotoru.detectSphere(geometry);
        if (gpuSphereResult && gpuSphereResult.quality > 85) {
            // Cache'e ekle
            const cacheEntry: CachedGeometryAnalysis = {
                surfaceType: 'kure',
                accuracy: gpuSphereResult.quality,
                avgRadius: gpuSphereResult.radius,
                vertexCount: posAttr.count,
                hashedBounds: geometry.uuid,
                timestamp: Date.now()
            };
            geometryAnalysisCache.set(geometry, cacheEntry);

            return {
                tip: 'egri',
                icerik: {
                    avgRadius: gpuSphereResult.radius,
                    center: gpuSphereResult.center,
                    accuracy: gpuSphereResult.quality,
                    tipi: 'kure'
                }
            };
        }
    } catch (e) {
        // GPU sphere failed
    }

    // 🚀 GPU Silindir tespiti dene
    try {
        const gpuCylinderResult = await gpuOlcumMotoru.detectCylinder(geometry);
        if (gpuCylinderResult && gpuCylinderResult.quality > 80) {
            // Cache'e ekle
            const cacheEntry: CachedGeometryAnalysis = {
                surfaceType: 'silindir',
                accuracy: gpuCylinderResult.quality,
                avgRadius: gpuCylinderResult.radius,
                vertexCount: posAttr.count,
                hashedBounds: geometry.uuid,
                timestamp: Date.now()
            };
            geometryAnalysisCache.set(geometry, cacheEntry);

            return {
                tip: 'egri',
                icerik: {
                    avgRadius: gpuCylinderResult.radius,
                    center: gpuCylinderResult.center,
                    axis: gpuCylinderResult.axis,
                    accuracy: gpuCylinderResult.quality,
                    tipi: 'silindir'
                }
            };
        }
    } catch (e) {
        // GPU cylinder failed
    }

    // 🚀 GPU Koni tespiti dene
    try {
        const gpuConeResult = await gpuOlcumMotoru.detectCone(geometry);
        if (gpuConeResult && gpuConeResult.quality > 75) {
            // Cache'e ekle
            const cacheEntry: CachedGeometryAnalysis = {
                surfaceType: 'koni',
                accuracy: gpuConeResult.quality,
                vertexCount: posAttr.count,
                hashedBounds: geometry.uuid,
                timestamp: Date.now()
            };
            geometryAnalysisCache.set(geometry, cacheEntry);

            return {
                tip: 'egri',
                icerik: {
                    apex: gpuConeResult.apex,
                    axis: gpuConeResult.axis,
                    angle: gpuConeResult.angle, // Yarım açı (derece)
                    accuracy: gpuConeResult.quality,
                    tipi: 'koni'
                }
            };
        }
    } catch (e) {
        // GPU cone failed
    }

    // 🚀 GPU Torus (Halka) tespiti dene
    try {
        const gpuTorusResult = await gpuOlcumMotoru.detectTorus(geometry);
        if (gpuTorusResult && gpuTorusResult.quality > 70) {
            // Cache'e ekle
            const cacheEntry: CachedGeometryAnalysis = {
                surfaceType: 'torus',
                accuracy: gpuTorusResult.quality,
                avgRadius: gpuTorusResult.majorRadius,
                vertexCount: posAttr.count,
                hashedBounds: geometry.uuid,
                timestamp: Date.now()
            };
            geometryAnalysisCache.set(geometry, cacheEntry);

            return {
                tip: 'egri',
                icerik: {
                    center: gpuTorusResult.center,
                    axis: gpuTorusResult.axis,
                    majorRadius: gpuTorusResult.majorRadius, // Merkeze olan mesafe (R)
                    minorRadius: gpuTorusResult.minorRadius, // Tüp yarıçapı (r)
                    accuracy: gpuTorusResult.quality,
                    tipi: 'torus'
                }
            };
        }
    } catch (e) {
        // GPU torus failed
    }

    // 🚀 GPU Düzlem tespiti dene
    try {
        const gpuPlaneResult = await gpuOlcumMotoru.detectPlane(geometry);
        if (gpuPlaneResult && gpuPlaneResult.quality > 90) {
            // Cache'e ekle
            const cacheEntry: CachedGeometryAnalysis = {
                surfaceType: 'duzlem',
                accuracy: gpuPlaneResult.quality,
                vertexCount: posAttr.count,
                hashedBounds: geometry.uuid,
                timestamp: Date.now()
            };
            geometryAnalysisCache.set(geometry, cacheEntry);

            return {
                tip: 'duzlem',
                icerik: {
                    point: gpuPlaneResult.point,
                    normal: gpuPlaneResult.normal,
                    accuracy: gpuPlaneResult.quality,
                    tipi: 'duzlem'
                }
            };
        }
    } catch (e) {
        // GPU plane failed
    }

    // CPU Fallback - mevcut sync fonksiyonu kullan
    return yuzeyTipiTespit(geometry);
}

/**
 * 🚀 GPU-ACCELERATED: Küre kontrolü - Async versiyon
 * @param geometry THREE.BufferGeometry
 * @returns Promise<{ yaricap, merkez, dogruluk } | null>
 */
export const kureKontrolGPU = async (geometry: THREE.BufferGeometry): Promise<{
    yaricap: number;
    merkez: THREE.Vector3;
    dogruluk: number;
} | null> => {
    try {
        const gpuResult = await gpuOlcumMotoru.detectSphere(geometry);
        if (gpuResult && gpuResult.quality > 85) {
            return {
                yaricap: gpuResult.radius,
                merkez: gpuResult.center,
                dogruluk: gpuResult.quality
            };
        }
    } catch (e) {
        // GPU failed
    }

    // CPU Fallback
    const posAttr = geometry.attributes.position;
    const points: FikoVektor3D[] = [];
    for (let i = 0; i < posAttr.count; i++) {
        points.push(new FikoVektor3D(posAttr.getX(i), posAttr.getY(i), posAttr.getZ(i)));
    }

    // İlk merkez tahmini
    let initialCenter = new FikoVektor3D(0, 0, 0);
    for (let p of points) {
        initialCenter.add(p);
    }
    initialCenter.divideScalar(points.length);

    const filteredPoints = filterOutliersByIQR(points, initialCenter);
    if (filteredPoints.length === 0) return null;

    let center = new FikoVektor3D(0, 0, 0);
    for (let p of filteredPoints) {
        center.add(p);
    }
    center.divideScalar(filteredPoints.length);

    let radiusSum = 0;
    const radiuses: number[] = [];
    for (let p of filteredPoints) {
        const dist = p.clone().sub(center).length();
        radiuses.push(dist);
        radiusSum += dist;
    }

    const avgRadius = radiusSum / filteredPoints.length;
    const tolerance = Math.max(0.1, avgRadius * 0.05);

    let deviationCount = 0;
    let maxDeviation = 0;
    for (let r of radiuses) {
        const dev = Math.abs(r - avgRadius);
        if (dev > maxDeviation) maxDeviation = dev;
        if (dev > tolerance) deviationCount++;
    }

    const dogruluk = ((points.length - deviationCount) / points.length) * 100;

    if (dogruluk > 85 && maxDeviation < avgRadius * 0.15) {
        return {
            yaricap: avgRadius,
            merkez: new THREE.Vector3(center.x, center.y, center.z),
            dogruluk: dogruluk
        };
    }

    return null;
}

/**
 * 🚀 GPU-ACCELERATED: Silindir kontrolü - Async versiyon
 * PCA (Principal Component Analysis) ile eksen bulma
 * @param geometry THREE.BufferGeometry
 * @returns Promise<{ yaricap, merkez, eksen, dogruluk } | null>
 */
export const silinderKontrolGPU = async (geometry: THREE.BufferGeometry): Promise<{
    yaricap: number;
    merkez: THREE.Vector3;
    eksen: THREE.Vector3;
    dogruluk: number;
} | null> => {
    try {
        const gpuResult = await gpuOlcumMotoru.detectCylinder(geometry);
        if (gpuResult && gpuResult.quality > 80) {
            return {
                yaricap: gpuResult.radius,
                merkez: gpuResult.center,
                eksen: gpuResult.axis,
                dogruluk: gpuResult.quality
            };
        }
    } catch (e) {
        // GPU failed
    }

    // CPU Fallback - basit silindir kontrolü
    const posAttr = geometry.attributes.position;
    const vertexCount = posAttr.count;
    if (vertexCount < 6) return null;

    // 1. Centroid hesapla
    let sumX = 0, sumY = 0, sumZ = 0;
    for (let i = 0; i < vertexCount; i++) {
        sumX += posAttr.getX(i);
        sumY += posAttr.getY(i);
        sumZ += posAttr.getZ(i);
    }
    const center = new THREE.Vector3(sumX / vertexCount, sumY / vertexCount, sumZ / vertexCount);

    // 2. Covariance matrix hesapla (3x3)
    let cov00 = 0, cov01 = 0, cov02 = 0;
    let cov11 = 0, cov12 = 0, cov22 = 0;

    for (let i = 0; i < vertexCount; i++) {
        const dx = posAttr.getX(i) - center.x;
        const dy = posAttr.getY(i) - center.y;
        const dz = posAttr.getZ(i) - center.z;

        cov00 += dx * dx;
        cov01 += dx * dy;
        cov02 += dx * dz;
        cov11 += dy * dy;
        cov12 += dy * dz;
        cov22 += dz * dz;
    }

    // Normalize
    cov00 /= vertexCount;
    cov01 /= vertexCount;
    cov02 /= vertexCount;
    cov11 /= vertexCount;
    cov12 /= vertexCount;
    cov22 /= vertexCount;

    // 3. Power iteration - principal eigenvector (20 iterations)
    let vx = 1, vy = 0, vz = 0;
    for (let iter = 0; iter < 20; iter++) {
        const newVx = cov00 * vx + cov01 * vy + cov02 * vz;
        const newVy = cov01 * vx + cov11 * vy + cov12 * vz;
        const newVz = cov02 * vx + cov12 * vy + cov22 * vz;

        const len = Math.sqrt(newVx * newVx + newVy * newVy + newVz * newVz);
        if (len > 0.0001) {
            vx = newVx / len;
            vy = newVy / len;
            vz = newVz / len;
        }
    }
    const axis = new THREE.Vector3(vx, vy, vz);

    // 4. Radial mesafeleri hesapla (eksenden dik mesafe)
    let sumRadius = 0, minRadius = Infinity, maxRadius = -Infinity;
    const radialDistances: number[] = [];

    for (let i = 0; i < vertexCount; i++) {
        const dx = posAttr.getX(i) - center.x;
        const dy = posAttr.getY(i) - center.y;
        const dz = posAttr.getZ(i) - center.z;

        // Eksene paralel bileşen
        const axialDist = dx * vx + dy * vy + dz * vz;

        // Eksene dik vektör
        const perpX = dx - axialDist * vx;
        const perpY = dy - axialDist * vy;
        const perpZ = dz - axialDist * vz;

        // Radyal mesafe
        const radialDist = Math.sqrt(perpX * perpX + perpY * perpY + perpZ * perpZ);
        radialDistances.push(radialDist);
        sumRadius += radialDist;
        minRadius = Math.min(minRadius, radialDist);
        maxRadius = Math.max(maxRadius, radialDist);
    }

    const avgRadius = sumRadius / vertexCount;

    // 5. Quality hesapla - radial mesafe tutarlılığı
    const tolerance = Math.max(0.1, avgRadius * 0.05);
    let inToleranceCount = 0;
    for (const dist of radialDistances) {
        if (Math.abs(dist - avgRadius) <= tolerance) {
            inToleranceCount++;
        }
    }
    const dogruluk = (inToleranceCount / vertexCount) * 100;

    // Silindir olarak kabul edilebilir mi?
    if (dogruluk > 80 && (maxRadius - minRadius) < avgRadius * 0.3) {
        return {
            yaricap: avgRadius,
            merkez: center,
            eksen: axis,
            dogruluk: dogruluk
        };
    }

    return null;
}
